import { api } from '../services/api.js';
import { prepareIdentityFile } from './imageDownscale.js';

/**
 * 393: a payment receipt goes up as `penalty_receipt` (file before purpose), and its id is then attached to what it
 * pays. 421 attaches it to a late extension paid by CARii's QR the same way. A PDF goes as it is; a photo is downscaled.
 */
export async function uploadPaymentReceipt(file: File): Promise<string> {
  const prepared = file.type === 'application/pdf' ? file : await prepareIdentityFile(file);
  const form = new FormData();
  form.append('file', prepared, prepared.name);
  form.append('purpose', 'penalty_receipt');
  const result = (await api.upload('/files/upload', form)) as { id: string };
  return result.id;
}
